<script setup lang="ts">
import type { BaseItem } from '~/models/Content/BaseItem'
import { computed } from 'vue'
import { useUrlBuilder } from '~/composables/useUrlBuilder'
import { useContentHelper } from '~/composables/useContentHelper'
import LinkOrAnchor from '~/components/utils/LinkOrAnchor.vue'

const props = defineProps<{
  resource: BaseItem
}>()

const { getTitle } = useContentHelper()
const { buildResourceUrl } = useUrlBuilder()

const title = computed(() => getTitle(props.resource))
const link = computed(() => buildResourceUrl(props.resource))
</script>

<template>
  <LinkOrAnchor :link="link" class="group relative flex aspect-square transition">
    <h3 class="bg-seagreen-60 group-hover:bg-seagreen-50 absolute top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2 rounded-lg px-6 py-3 text-xl leading-tight font-semibold transition group-focus-visible:ring">
      {{ title }}
    </h3>
    <img
      v-if="resource.thumbnail"
      class="absolute bottom-0 w-full duration-200 group-hover:scale-110"
      :src="resource.thumbnail"
      :alt="resource.thumbnailAlt || ''"
    >
  </LinkOrAnchor>
</template>
